export enum BorderStyle {
    dashed = 'dashed',
    solid = 'solid',
    none = 'none',
}
